// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContactsTwoToneSvg from "@ant-design/icons-svg/es/asn/ContactsTwoTone";
import AntdIcon from '../components/AntdIcon';

var ContactsTwoTone = function ContactsTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContactsTwoToneSvg
  }));
};

ContactsTwoTone.displayName = 'ContactsTwoTone';
export default React.forwardRef(ContactsTwoTone);